import { TERMINAL_STATUSES } from "src/constants/order.constant";
import { orderBundleFields } from "src/utils/bundles";

type ResumedOrder = {
  status?: string | null;
  orderPhotos?: Array<{ photos?: Array<unknown> | null }> | null;
  orderProductDetails?: unknown[] | null;
  orderCalendars?: unknown[] | null;
  productWithMediaOrders?: unknown[] | null;
};

/**
 * The upload pre-flight's question: is the cart it is about to resume a dead
 * one? Dead means already finalized, or its photos were purged and there is
 * nothing else left. A selected bundle is content: "Izberi paket" creates an
 * empty order to hold it, and discarding that order drops the selection.
 */
export function resumedOrderState(resumed: ResumedOrder): {
  stale: boolean;
  terminal: boolean;
  livePhotoCount: number;
} {
  const terminal =
    !!resumed.status &&
    (TERMINAL_STATUSES as readonly string[]).includes(resumed.status);
  const livePhotoCount = (resumed.orderPhotos ?? []).reduce(
    (n, op) =>
      n +
      (op.photos ?? []).filter(
        (p) => (p as { deleted?: unknown } | null)?.deleted == null
      ).length,
    0
  );
  const hasOtherItems =
    (resumed.orderProductDetails?.length ?? 0) > 0 ||
    (resumed.orderCalendars?.length ?? 0) > 0 ||
    (resumed.productWithMediaOrders?.length ?? 0) > 0 ||
    !!orderBundleFields(resumed).selectedBundleId;
  return {
    stale: terminal || (livePhotoCount === 0 && !hasOtherItems),
    terminal,
    livePhotoCount,
  };
}
